import classNames from 'classnames';
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutlet,
  useParams,
} from 'react-router-dom';
import { AssetView } from '~/components/assets/AssetView';

export default function AssetLayout() {
  const outlet = useOutlet();
  const { assetId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('..');
  };

  const isCalendarView = location.pathname.includes('/jobs/calendar');

  return (
    <div className='relative flex h-full'>
      <div
        className={classNames('flex-1', {
          // When no outlet, AssetView takes full width
          'w-full': !outlet,
          // When outlet exists, AssetView takes left side
          'xl:w-rsb xl:flex-none': outlet,
        })}
      >
        <AssetView id={assetId} />
      </div>
      {outlet && (
        <div
          data-outlet
          className={classNames(
            'absolute z-50 h-full w-full xl:w-[414px]',
            !isCalendarView ? 'xl:relative' : ''
          )}
        >
          <Outlet />
        </div>
      )}
    </div>
  );
}
